module.exports = __webpack_public_path__ + "static/media/gda.fe8feb6f.jpg";